import { Check, Close, ExpandMore } from '@mui/icons-material';
import { Accordion, AccordionDetails, Typography, useEventCallback } from '@mui/material';
import { AccordionSummary } from 'shell/components/shared/summary-accordion';
import {
  CancellationDueDeath,
  DeathDataForm,
} from 'cancellations/view-models/cancellation-due-death';
import { memo, useMemo } from 'react';
import { FormikErrors, FormikTouched, useFormikContext } from 'formik';
import DeathDataFormComponentMemo from './death-data-form';

interface DeathDataAccordionProps {
  expanded: boolean;
  toggle: () => void;
  disabled?: boolean;
}

const DeathDataAccordionComponent = ({
  expanded,
  toggle,
  disabled,
}: DeathDataAccordionProps): React.ReactElement => {
  const formContext = useFormikContext<CancellationDueDeath>();
  const { deathDataForm } = formContext.values;
  const errors: FormikErrors<DeathDataForm> | undefined = formContext.errors
    ?.deathDataForm as FormikErrors<DeathDataForm>;
  const touched: FormikTouched<DeathDataForm> | undefined = formContext.touched
    ?.deathDataForm as unknown as FormikTouched<DeathDataForm>;

  const handleFormFieldChange = useEventCallback(
    (key: keyof DeathDataForm, value: DeathDataForm[keyof DeathDataForm]) => {
      const newForm = {
        ...(formContext.values.deathDataForm || {}),
        [key]: value,
      };
      formContext.setFieldValue('deathDataForm', newForm);
    }
  );

  const handleFormFieldChanges = useEventCallback((values: DeathDataForm) => {
    const newForm = {
      ...(formContext.values.deathDataForm || {}),
      ...(values || {}),
    };
    formContext.setFieldValue('deathDataForm', newForm);
  });

  const error = useMemo(() => {
    return !!errors;
  }, [errors]);

  return (
    <Accordion expanded={expanded} onChange={toggle}>
      <AccordionSummary
        aria-controls="panel-death-data-content"
        id="panel-death-data-content"
        expandIcon={<ExpandMore />}
      >
        {error ? <Close color="error" /> : <Check color="success" />}
        <Typography>Dati decesso</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <DeathDataFormComponentMemo
          errors={errors}
          touched={touched}
          deathDataForm={deathDataForm}
          handleFormFieldChange={handleFormFieldChange}
          handleFormFieldChanges={handleFormFieldChanges}
          disabled={disabled}
        />
      </AccordionDetails>
    </Accordion>
  );
};

DeathDataAccordionComponent.displayName = 'Death data accordion component';

const DeathDataAccordion = memo(DeathDataAccordionComponent);

export default DeathDataAccordion;
